@if (canView) {
    @if (!isOpen) {
        <div class="flex flex-row items-center justify-center">
            <button (click)="clickedOpen()" class="p-2 rounded-sm shadow-sm text-sm bg-slate-100 text-slate-600 border border-opacity-0 border-ponder-link hover:border-opacity-100 hover:text-ponder-link disabled:text-slate-400 disabled:hover:border-opacity-0">
                View Admin Controls
            </button>
        </div>
    } @else {
        <div class="flex flex-col w-full shadow bg-slate-100 rounded-md text-md">
            <div class="flex flex-row bg-ponder-light text-slate-50 rounded-t-md p-2 shadow items-center">
                <div>Admin</div>
                <div class="grow text-right text-xs">{{ magicCard.id }}</div>
            </div>
            <div class="p-2 flex flex-col text-sm">
                @if (isLoading || !loadingSuccess) {
                    <loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>
                } @else {
                    <div class="flex flex-col bg-slate-50 p-2 gap-2 rounded-sm shadow-sm">
                        <div class="flex flex-row gap-2 items-center">
                            <input #updateImageCheck type="checkbox">
                            <div class="w-[12ch]">Refesh Image</div>
                        </div>
                        <div class="flex flex-row gap-2 items-center">
                            <input #moveToSetCheck type="checkbox">
                            <div class="w-[12ch]">Move to Set</div>
                        </div>
                        <div class="w-full">
                            <div class="flex flex-row gap-2">
                                <select #viewMagicSetSelect class="p-[5px] rounded-sm shadow-sm bg-white max-w-[60%]">
                                    @for (set of visibleMagicSets ; track set.id!) {
                                        <option [attr.value]="set.code!">{{ set.name! }} ({{ set.code! }})</option>
                                    }
                                </select>
                                <div class="grow"></div>
                                <input #viewMagicSetFilter (input)="onMagicSetFilterChange(viewMagicSetFilter.value, moveToSetCheck)" class="p-[5px] rounded-sm shadow-sm bg-white min-w-[20%] text-center" placeholder="filter">
                            </div>
                        </div>
                        <div class="flex flex-row justify-end items-center gap-2">
                            @if (!updatingSuccess) {
                                <div class="text-red-600">
                                    Uh oh! Something went wrong ...
                                </div>
                            }
                            @if (!isUpdating) {
                                <button (click)="onUpdateClicked(updateImageCheck, moveToSetCheck, viewMagicSetSelect)" class="p-1 rounded-sm shadow-sm w-[10ch] bg-white border border-opacity-0 border-ponder-link hover:border-opacity-100 hover:text-ponder-link disabled:text-slate-400 disabled:hover:border-opacity-0">
                                    Update
                                </button>
                            } @else {
                                <busy-spin class="p-1"></busy-spin>
                            }
                        </div>
                    </div>
                    <div class="pt-[2px] text-xs text-slate-400">
                        Note: It may take up to 24 hours to reflect image updates.
                    </div>
                }
            </div>
        </div>
    }
}